import store from '../../store'

export function hideMeetingsPageBanner() {	
	store.dispatch({ type:'HIDE_INTEGRATION_BANNER'})
}



